import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import './app/formio-file-dropzone.patch';   // BUG-008 (BATCH 109): Form.io file drop zone comes back after a refused file

if (environment.production) {
  enableProdMode();
}

// register firebase-messaging-sw.js service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    console.log('Firebase messaging service worker registered', registration);
  }).catch((err) => {
    console.error('Service worker registration failed', err);
  });
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  useJit: true,
  preserveWhitespaces: true
})
  .catch(err => console.log(err));
